import React, { Fragment } from 'react';
import { useField } from 'formik';
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import SummaryItem from "../components/SummaryItem/SummaryItem";
import { toInputUppercase} from '../../../helpers/helpers';
export default function PasswordField(props) {
  const { errorText, ...rest } = props;
  const [field, meta] = useField(props);
  const { summaryMode } = rest;
  const { t } = useTranslation();
  const hasIcon = props.leftIcon ? 'has-icon' : '';
  let labelFormatted = rest.label;
  if (summaryMode) {
    labelFormatted = rest.summaryLabel ? rest.summaryLabel : rest.label;
  }
  return (
    <Form.Group controlId={field.name}
                className={(meta.touched && meta.error) ? 'has-error' : ''}>
      {
        !summaryMode ? (
          <>
            <Form.Label
            style={{ display: labelFormatted ? 'block' : "none" }}>{labelFormatted}</Form.Label>
            <Fragment>
              <Form.Control
                type="password"
                name={field.name}
                // to deal with the translations for the plaholder [object Object]
                placeholder={typeof rest.placeholder === 'object' ? t(rest.placeholder.props.i18nKey) : rest.placeholder}
                value={field.value || ''}
                onChange={field.onChange}
                className={(meta.touched && meta.error) ? `${hasIcon} is-invalid` : `${hasIcon} nothing`}
                disabled={rest.disabled}
                readOnly={rest.readonly}
                onInput= {rest.uppercase ? toInputUppercase : null }
                // TODO : the background color for read only is not visible
                style={{ backgroundColor: "#eef1f7" }}
              />
              {(meta.touched && meta.error) &&
              <div className="invalid-feedback" style={{ display: 'block' }}>{meta.error}</div>}
              {rest.leftIcon && <i className={rest.leftIcon} aria-hidden="true"></i>}

            </Fragment>
          </>
        ) : (
          <>
            <span className="paragraph-small-fs9" style={{ display: labelFormatted ? 'block' : "none" }}>{labelFormatted}</span>
            <SummaryItem value={field.value} error={meta.error} />
          </>
        )
      }
      {props.subtitle ? <Form.Text
        style={{ border: '1px solid #b1894d', backgroundColor: '#f9f1c6', padding: '8px', borderRadius: '4px' }}
        className="text-muted">
        <div style={{ width: '50%', color: '#b1894d', fontWeight: 'bold' }}>{props.subtitle}</div>
      </Form.Text> : null}

    </Form.Group>
  );
}
